import React from 'react';
import styles from './MaintenancePage.module.scss';
import { MaintenanceStatus } from '../../services/maintenance';

// Inline SVG icons to avoid icon library import overhead
const WrenchIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
  </svg>
);

const ClockIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const RefreshIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
  </svg>
);

interface MaintenancePageProps {
  maintenance: MaintenanceStatus;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ maintenance }) => {
  const formatEstimatedEnd = (isoString: string): string => {
    const date = new Date(isoString);
    return date.toLocaleString('id-ID', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={styles.page}>
      <div className={styles.backgroundPattern} aria-hidden="true" />

      <div className={styles.card} role="main">
        <div className={styles.logoWrapper}>
          <img src="/images/logo-lazismu.png" alt="Lazismu UMMI" />
        </div>

        <div className={styles.iconWrapper} aria-hidden="true">
          <WrenchIcon />
        </div>

        <h1 className={styles.title}>Sedang dalam Pemeliharaan</h1>
        <p className={styles.subtitle}>
          Kami sedang melakukan peningkatan sistem untuk memberikan pengalaman donasi yang lebih baik.
        </p>

        {maintenance.message && (
          <div className={styles.message} role="status">
            {maintenance.message}
          </div>
        )}

        {maintenance.estimatedEnd && (
          <div className={styles.estimatedEnd}>
            <ClockIcon />
            <span>
              Estimasi selesai: <strong>{formatEstimatedEnd(maintenance.estimatedEnd)}</strong>
            </span>
          </div>
        )}

        <div className={styles.divider} />

        <p className={styles.footer}>
          Mohon maaf atas ketidaknyamanan ini. Terima kasih atas kesabaran Anda.
          <br />
          <br />
          <strong>LAZISMU UMMI</strong> — Lembaga Amil Zakat, Infak, dan Shadaqah
        </p>

        <div className={styles.refreshHint}>
          <button
            onClick={() => window.location.reload()}
            aria-label="Coba muat ulang halaman"
          >
            <RefreshIcon />
            Coba lagi
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
